// Time options for dropdowns
export const CHECK_OUT_TIME_OPTIONS = [
  '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30',
  '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
  '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30',
  '22:00', '22:30', '23:00', '23:30'
];

export const CHECK_IN_TIME_OPTIONS = [
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
  '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'
];

export const CLEANING_BUFFER_OPTIONS = [
  { value: 30, label: '30 min' },
  { value: 60, label: '60 min' },
  { value: 90, label: '90 min' },
  { value: 120, label: '120 min' }
];

export const DISPATCH_STRATEGY_OPTIONS = [
  { value: 'all_per_round', label: 'All cleaners per round' },
  { value: 'priority_first', label: 'Priority first (all rounds per cleaner)' }
];

export const PROPERTY_TYPE_OPTIONS = [
  'Apartment', 'House', 'Studio', 'Room', 'Villa', 'Condo', 'Beach House', 'Cabin'
];

export const BEDROOM_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const BATHROOM_OPTIONS = [1, 2, 3, 4, 5];

// Pick display name based on browser language (Spanish → name, else → name_en)
export const isSpanish = () => (navigator.language || '').toLowerCase().startsWith('es');
export const displayName = (space) => isSpanish() ? (space.name || space.name_en) : (space.name_en || space.name);

// Generate spaces config from room structure (mirrors backend logic)
export const generateSpacesConfig = (numBedrooms, numBathrooms, hasKitchen, hasLivingRoom) => {
  const spaces = [];
  let order = 1;
  if (hasLivingRoom) {
    spaces.push({ name: 'Sala de estar', name_en: 'Living Room', order: order++, required: true });
  }
  const beds = numBedrooms || 1;
  for (let i = 1; i <= beds; i++) {
    const suffix = beds > 1 ? ` ${i}` : '';
    spaces.push({ name: `Dormitorio${suffix}`, name_en: `Bedroom${suffix}`, order: order++, required: true });
  }
  const baths = numBathrooms || 1;
  for (let i = 1; i <= baths; i++) {
    const suffix = baths > 1 ? ` ${i}` : '';
    spaces.push({ name: `Baño${suffix}`, name_en: `Bathroom${suffix}`, order: order++, required: true });
  }
  if (hasKitchen) {
    spaces.push({ name: 'Cocina', name_en: 'Kitchen', order: order++, required: true });
  }
  return spaces;
};

// Default new property state
export const DEFAULT_NEW_PROPERTY = {
  name: '',
  address: '',
  property_type: 'Apartment',
  city: '',
  zip_code: '',
  country: '',
  ical_url: '',
  check_in_time: '15:00',
  check_out_time: '11:00',
  cleaning_buffer: 60,
  dispatch_strategy: 'all_per_round',
  num_bedrooms: 1,
  num_bathrooms: 1,
  has_kitchen: true,
  has_living_room: true,
  spaces_config: null,
  seam_device_id: '',
  is_test: false,
};
